<template>
    <div>
        <div class="flex h-screen w-full overflow-hidden">
            <div class="h-full hidden md:block">
                <div class="h-full flex flex-col bg-[#091524] text-gray-200 w-[220px] overflow-hidden relative">
                    <div class="flex items-center justify-center pt-4 pb-4 border-b px-10">
                        <img class="h-16" src="@/assets/images/jana-white-logo.png" />
                    </div>
                    <div class="flex-1 overflow-y-auto">
                        <MenuBox></MenuBox>
                    </div>
                </div>
            </div>
            <div class="flex-1 flex flex-col h-screen overflow-x-auto">
                <AdminTopBox></AdminTopBox>
                <div class="p-3 flex-1 overflow-y-auto">
                    <router-view />
                </div>
            </div>
        </div>
        <!-- task list -->
        <GlobalTastBox></GlobalTastBox>
        <FillInOperatorInfo ref="fillInOperatorInfo"></FillInOperatorInfo>
    </div>
</template>

<script>
import AdminTopBox from "@/components/admin-top-box.vue"
import FillInOperatorInfo from "@/components/FillInOperatorInfo.vue"
import GlobalTastBox from "@/components/global-tast-box.vue"
import MenuBox from "@/components/menu-box.vue"
import { mapGetters } from "vuex"
export default {
    components: {
        AdminTopBox,
        MenuBox,
        GlobalTastBox,
        FillInOperatorInfo,
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            adminInfo: "adminInfo",
        }),
    },
    mounted() {
        const shouldShow = (() => {
            try {
                return !!localStorage.getItem("showFillInModalAfterLogin")
            } catch (e) {
                return false
            }
        })()

        if (shouldShow && (!this.adminInfo || !this.adminInfo.fullName)) {
            this.$refs.fillInOperatorInfo.show()
            try {
                localStorage.removeItem("showFillInModalAfterLogin")
            } catch (e) {
                // intentionally ignore storage errors
            }
        }
    },
    methods: {},
}
</script>
